import React from 'react';

const WrittenResponseQuestion = ({ setAnswer }) => {
  return (
    <div className="WrittenResponseQuestion">
      <textarea
        placeholder={t(
          'questions.question.written_response.textarea_placeholder',
        )}
        className="WrittenResponseQuestion-textbox"
        onChange={e => setAnswer(e.target.value.trim())}
      />
    </div>
  );
};

export default WrittenResponseQuestion;
